import React, { useState } from 'react'

import classNames from 'classnames'
import { LinkBox, Box } from 'front-end/src/components'
import { LinkBoxProps } from '@chakra-ui/react'

import './Dropdown.less'

export interface LinkOverlayBasicProps {
  show?: boolean
  children: any
  className?: string
  content?: any
  disabled?: boolean
  positionOfContent?: 'left' | 'right'
}

type LinkOverlayProps = LinkOverlayBasicProps & LinkBoxProps

export const Dropdown: React.FC<LinkOverlayProps> = (props) => {
  const {
    children,
    className,
    content,
    positionOfContent,
    disabled,
    minW,
    ...rest
  } = props
  const [show, setShow] = useState(props.show)
  const handler = () => {
    setShow(!show)
  }

  return (
    <LinkBox
      onClick={handler}
      tabIndex={props.tabIndex ?? 0}
      className={classNames(
        'Dropdown',
        className,
        { disable: disabled },
        { show },
        { hide: !show },
        positionOfContent ?? 'right'
      )}
      aria-expanded={show}
      {...rest}
    >
      {children}
      <div className="Dropdown__animator" aria-hidden="false">
        <Box
          className="Dropdown__content"
          aria-live="polite"
          aria-atomic="true"
          minW={minW}
        >
          {content}
        </Box>
      </div>
      {show && (
        <span
          className="Dropdown__mask"
          onClick={() => {
            setShow(!show)
          }}
        />
      )}
    </LinkBox>
  )
}
